import { createContext, useContext } from "react";

/** Phase 90 — données de l'éditeur partagées avec les champs de section (ex. liste des formulaires modules exposables). */
export const BuilderContext = createContext({ modules: { forms: [], minisite_hidden: [] } });
export const useBuilderData = () => useContext(BuilderContext);
